import { createSlice, createAction, PayloadAction, createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/state/store'
import { ApiError, RequestStatus } from 'features/common'
import { User } from '../types'

export const name = 'users'

export interface UserState {
  me?: User
  meStatus?: RequestStatus
  meError?: ApiError | null
  accountIsReadyStatus: number | undefined
  accountIsReadyError: ApiError | null
  justLoggedIn: boolean
}

const initialState: UserState = {
  me: undefined,
  accountIsReadyStatus: undefined,
  accountIsReadyError: null,
  justLoggedIn: false
}

const asyncActions = {
  meRequest: createAction(`${name}/me_request`),
  userLoginMetricsRequest: createAction<User>(`${name}/userlogin_metrics_request`),
  checkAccountIsReadyStatusRequest: createAction<string>(`${name}/check_account_is_ready`),
  retryWhileAccountIsNotReadyRequest: createAction<string>(`${name}/retry_while_account_is_not_ready`)
}

const reducers = {
  setMe: (state: UserState, action: PayloadAction<User>) => {
    state.me = action.payload
  },
  setMeStatus: (state: UserState, action: PayloadAction<RequestStatus>) => {
    state.meStatus = action.payload
  },
  setMeError: (state: UserState, action: PayloadAction<ApiError | null>) => {
    state.meError = action.payload
  },
  setAccountIsReadyStatus: (state: UserState, action: PayloadAction<number>) => {
    state.accountIsReadyStatus = action.payload
  },
  setAccountIsReadyError: (state: UserState, action: PayloadAction<ApiError>) => {
    state.accountIsReadyError = action.payload
  },
  setJustLoggedIn: (state: UserState, action: PayloadAction<boolean>) => {
    state.justLoggedIn = action.payload
  }
}

export const usersSlice = createSlice({
  name,
  initialState,
  reducers
})

export const { setMe, setAccountIsReadyStatus, setAccountIsReadyError, setMeStatus, setMeError, setJustLoggedIn } =
  usersSlice.actions
export const {
  meRequest,
  userLoginMetricsRequest,
  checkAccountIsReadyStatusRequest,
  retryWhileAccountIsNotReadyRequest
} = asyncActions

export const userAccountIsReady = createSelector(
  (state: RootState) => state.users,
  (users) => {
    return users.accountIsReadyStatus === 204 && users.me?.user_metadata?.tenant_domain
  }
)

export default usersSlice.reducer
